import { Pipe, PipeTransform } from '@angular/core';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';

/**
 * Generated class for the RelativeTimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'relativeTime',
})
export class RelativeTimePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
   transform(value: string, ...args) {
     return formatDistanceToNow(new Date(value), { addSuffix: true });
   }
 }



// WEBPACK FOOTER //
// ./src/pipes/relative-time/relative-time.ts